import React, { useEffect, useState, useContext } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import LabeledInput from '../common/LabeledInput.jsx';
import StyledInput from '../common/StyledInput.jsx';
import Images from '../common/Images.jsx';
import requests from '../utils/requests.js';
import functions from '../utils/functions.js';
import { s } from '../Style.jsx';
import AutocompleteAny from '../common/AutocompleteAny.jsx';

const Vendors = () => {

    const [editingVendor, setVendor] = useState(false);
    const [editingVendorId, editVendorId] = useState(false);

    const { auth } = useContext(PersonContext);

    const [vendors, setVendors] = useState(null);
    useEffect(() => {
        requests.getVendors(auth).then(vendors => {
            setVendors(vendors);
        });
    }, []);

    const [people, setPeople] = useState([]);
    useEffect(() => { requests.getPeople(auth).then(people => setPeople(people)) }, []);

    const [savingVendor, setSavingVendor] = useState(false);
    const saveVendor = async () => {
        setSavingVendor(true);
        await requests.updateVendor(auth, {
            name: editingVendor.name,
            address: editingVendor.address,
            phone: editingVendor.phone,
            deliveryFee: editingVendor.deliveryFee,
            onaccount: editingVendor.onaccount,
            enableMenus: editingVendor.enableMenus,
            images: editingVendor.images,
            comissionRate: editingVendor.comissionRate,
            uid: editingVendor.uid,
            website: editingVendor.website,
            description: editingVendor.description,
            showInApp: editingVendor.showInApp,
        }, editingVendorId);
        requests.getVendors(auth).then(vendors => {
            setSavingVendor(false);
            setVendors(vendors);
        });
    };

    const [addingVendor, setAddingVendor] = useState(false);
    const newVendor = async () => {
        setAddingVendor(true);
        await requests.addVendor(auth);
        requests.getVendors(auth).then(vendors => {
            setVendors(vendors);
            setAddingVendor(false);
        });
    };

    const [deletePrompt, setDeletePrompt] = useState(false);
    const [deletingVendor, setDeletingVendor] = useState(false);
    const deleteConfirm = async () => {
        setDeletingVendor(true);
        setDeletePrompt(false);
        setVendor(false);
        editVendorId(false);
        await requests.deleteVendor(auth, editingVendorId);
        requests.getVendors(auth).then(vendors => {
            setVendors(vendors);
            setDeletingVendor(false);
        });
    };

    const [childVendors, setChildVendors] = useState([]);
    useEffect(() => {
        if (editingVendorId) {
            setChildVendors(vendors.filter(v => v.parentId === editingVendorId));
        }
    }, [editingVendorId, vendors]);

    const [loadingLocations, setLoadingLocations] = useState(false);

    return <div style={s.mobileContainer}>

        {(!vendors || addingVendor || savingVendor || deletingVendor) && <p><i className="fas fa-spinner fa-spin"></i></p>}

        {vendors && !addingVendor && !savingVendor && <>

            {!editingVendorId && <button style={s.button} onClick={newVendor}>Add Vendor</button>}

            {!!vendors.length && <div style={{ ...s.box, paddingBottom: 0 }}>
                <table style={s.table}>
                    {(!!editingVendorId ? [vendors.find(o => o.id == editingVendorId)] : vendors.filter(v => !v.parentId)).map((vendor, v) => <tr key={vendor.id} style={s.cell(v)}>
                        <td style={{ flex: .2 }}><s.IconButton icon="fas fa-edit" does={() => {
                            setDeletePrompt(false);
                            setVendor(vendor);
                            editVendorId(editingVendorId === vendor.id ? false : vendor.id);
                        }} /></td>
                        <td style={{ ...s.tableCell }}>{vendor.name}</td>
                    </tr>)}
                </table>
            </div>}

            {editingVendorId && <>
                {deletingVendor || savingVendor && <p><i className="fas fa-spinner fa-spin"></i></p>}
                {!deletingVendor && !savingVendor && <>

                    <h3 style={{ marginBottom: 10 }}>{editingVendor.name}</h3>

                    <div style={s.box}>
                        <div style={s.table}>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Name</label>
                                <LabeledInput value={editingVendor.name} onChange={value => setVendor({ ...editingVendor, name: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Address</label>
                                <LabeledInput value={editingVendor.address} onChange={value => setVendor({ ...editingVendor, address: value })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Store Manager</label>
                                <AutocompleteAny type="person" selected={editingVendor.uid} options={people.map(p => ({ ...p, name: p.phone[0] }))} onChange={(person) => setVendor({ ...editingVendor, uid: person.id })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Website URL</label>
                                <LabeledInput value={editingVendor.website} onChange={value => setVendor({ ...editingVendor, website: value })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Description</label>
                                <LabeledInput value={editingVendor.description} onChange={value => setVendor({ ...editingVendor, description: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Public Phone Number</label>
                                <LabeledInput value={editingVendor.phone} onChange={value => setVendor({ ...editingVendor, phone: value })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Delivery Fee</label>
                                <LabeledInput type="number" prefix="$" value={(editingVendor.deliveryFee)} onChange={value => setVendor({ ...editingVendor, deliveryFee: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Driver Comission Rate</label>
                                <LabeledInput type="number" prefix="%" value={(editingVendor.comissionRate)} onChange={value => setVendor({ ...editingVendor, comissionRate: value })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>On-Account</label>
                                <LabeledInput type="checkbox" value={editingVendor.onaccount} onChange={value => setVendor({ ...editingVendor, onaccount: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Store Menu</label>
                                <LabeledInput type="checkbox" value={editingVendor.enableMenus} onChange={value => setVendor({ ...editingVendor, enableMenus: value })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Show In App</label>
                                <LabeledInput type="checkbox" value={editingVendor.showInApp} onChange={value => setVendor({ ...editingVendor, showInApp: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <Images images={editingVendor.images} setImages={images => setVendor({ ...editingVendor, images })} />
                            </div>
                        </div>
                        <button onClick={() => {
                            saveVendor();
                        }}
                        >Save</button>
                    </div>

                    <h3 style={{ marginBottom: 10 }}>Additional Locations</h3>

                    {loadingLocations && <p><i className="fas fa-spinner fa-spin"></i></p>}
                    {!loadingLocations && <>

                        {childVendors.map((vendor, v) => <div key={vendor.id} style={{ ...s.box }}>
                            <div style={s.table}>
                                <div style={s.cell(1)}>
                                    <label style={{ flex: 1 }}>Address</label>
                                    <LabeledInput value={vendor.address} onChange={value => {
                                        setChildVendors(childVendors.map(v => { if (v.id === vendor.id) { return { ...v, address: value }; } return v; }));
                                    }} />
                                </div>
                                <div style={s.cell(0)}>
                                    <label style={{ flex: 1 }}>Store Manager</label>
                                    <AutocompleteAny  type="person" selected={vendor.uid} options={people} onChange={async (person) => {
                                        setChildVendors(childVendors.map(v => { if (v.id === vendor.id) { return { ...v, uid: person.id }; } return v; }));
                                    }} />
                                </div>
                                <div style={s.cell(1)}>
                                    <label style={{ flex: 1 }}>Delivery Fee</label>
                                    <LabeledInput type="number" prefix="$" value={(vendor.deliveryFee)} onChange={value => {
                                        setChildVendors(childVendors.map(v => { if (v.id === vendor.id) { return { ...v, deliveryFee: value }; } return v; }));
                                    }} />
                                </div>
                                <div style={s.cell(0)}>
                                    <label style={{ flex: 1 }}>Driver Comission Rate</label>
                                    <LabeledInput type="number" prefix="%" value={(vendor.comissionRate)} onChange={value => {
                                        setChildVendors(childVendors.map(v => { if (v.id === vendor.id) { return { ...v, comissionRate: value }; } return v; }));
                                    }} />
                                </div>
                                <div style={s.cell(1)}>
                                    <label style={{ flex: 1 }}>On-Account</label>
                                    <LabeledInput type="checkbox" value={vendor.onaccount} onChange={value => {
                                        setChildVendors(childVendors.map(v => { if (v.id === vendor.id) { return { ...v, onaccount: value }; } return v; }));
                                    }} />
                                </div>
                            </div>
                            <button style={{ marginTop: 10, marginRight: 5 }} onClick={async () => {
                                setLoadingLocations(true);
                                await requests.updateVendor(auth, {
                                    uid: vendor.uid,
                                    address: vendor.address,
                                    name: vendor.name,
                                    deliveryFee: vendor.deliveryFee,
                                    onaccount: vendor.onaccount,
                                    comissionRate: vendor.comissionRate,
                                }, vendor.id);
                                await requests.getVendors(auth).then(vendors => setVendors(vendors));
                                setLoadingLocations(false);
                            }}>Save Location</button>
                            <button style={{ marginTop: 10 }} onClick={async () => {
                                setLoadingLocations(true);
                                await requests.deleteVendor(auth, vendor.id);
                                await requests.getVendors(auth).then(vendors => setVendors(vendors));
                                setLoadingLocations(false);
                            }}>Delete Location</button>
                        </div>)}

                        <button style={{ marginTop: 10 }} onClick={async () => {
                            setAddingVendor(true);
                            await requests.addVendor(auth, { parentId: editingVendorId });
                            requests.getVendors(auth).then(vendors => {
                                setVendors(vendors);
                                setAddingVendor(false);
                            });
                        }}>Add Location</button>

                    </>}

                    <span style={{ fontSize: 14, textAlign: "right", display: "block", marginTop: 20 }}>
                        {deletePrompt
                            ? <>
                                <button style={{ marginLeft: 4 }} onClick={deleteConfirm}>Yes</button>
                                <button style={{ marginLeft: 4 }} onClick={() => setDeletePrompt(false)}>No</button>
                                <span style={{ fontSize: 12 }}>Are you sure you want to delete this vendor?</span>
                            </>
                            : <>
                                <button style={{ marginLeft: 4 }} onClick={() => setDeletePrompt(true)}>Delete Vendor</button>
                            </>}
                    </span>
                </>}
            </>}

        </>}
    </div >;
}
export default Vendors;